export default function WriteTabbarItemMobile({ currentTab, item, onClick }) {
    return (
        <div
            className={currentTab === item ? "f16_2E4A24_W500" : "f16_6B7280_W400"}
            style={{
                display: "flex",
                padding: "16px", borderBottom: currentTab === item && "2px solid #2E4A24",
                cursor: "pointer",
                transition: "all 0.3s ease-in-out", // 애니메이션
                borderRadius: "4px 4px 0px 0px",
                flex: "1",
                justifyContent: "center"
            }}
            /// ✅ 마우스 호버 효과
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#dfdfdf";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
            }}
            onClick={() => onClick()}
        >
            {item}
        </div>
    )
}